import React, { useContext } from 'react'
import { useTheme } from '@/context/ThemeContext'
import { Moon } from 'lucide-react'
import { Switch } from '@/components/ui/switch'
import { RemoteConfigContext } from '@/context/RemoteConfigContext'

export function ThemeToggle() {
  const { isDarkMode, toggleTheme } = useTheme()
  const { config, isLoading } = useContext(RemoteConfigContext)

  // If dark mode is disabled in remote config or still loading, don't show the toggle
  if (!config.darkMode || isLoading) {
    return null
  }

  return (
    <div className="w-full px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center justify-between text-gray-700 dark:text-gray-200">
      <div className="flex items-center">
        <Moon className="h-4 w-4 mr-2" />
        <span>Dark Mode</span>
      </div>
      <Switch checked={isDarkMode} onCheckedChange={toggleTheme} />
    </div>
  )
}
